import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesInputComponent } from './files-input.component';
import {DropzoneModule} from "ngx-dropzone-wrapper";



@NgModule({
  declarations: [FilesInputComponent],
  exports: [
    FilesInputComponent
  ],
  imports: [
    CommonModule,
    DropzoneModule
  ]
})
export class FilesInputModule { }
